/* eslint-disable */
import { ChevronLeft, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PlaceOrderBg from '../../assets/images/PlaceOrderBg.png'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'
import { toCurrency } from '../../utils/CurrencyUtil'
import { useModal } from '../../hooks/use-modal-store'
import env from '../../env/env'
import { post } from '../../http/restservice'
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import { messageModalState } from '../../store/Feedback'
import { MutualFundsSelectorDetails } from '../../store/MFStore'
import { Card } from '../../Components/ui/card'
import { AccountBalance } from '@mui/icons-material'
import { BankDetails } from '../../store/AccountDetailsStore'
import { formatIndianNumber, sanitizeName } from '../../utils/Util'
import { userDetailsState } from '../LoginState'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import PostHogTracker from '../../utils/PostHogTracker'

const MFRedeem = () => {
  const location = useLocation()
  console.log('🚀 ~ MFRedeem ~ location:', location)
  const [fundDetails] = useState(location?.state?.fundDetails)
  const [fund] = useState(location?.state?.fund)
  const fundPortfolio = useRecoilValueLoadable(
    MutualFundsSelectorDetails(location.state?.fundDetails.schemeCode),
  )

  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)

  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)
  const navigate = useNavigate()
  const { onOpen } = useModal()
  const [redemptionAmount, setRedemptionAmount] = useState(
    fund?.holding ? fund.holding.toFixed(3) : '0.00',
  )

  const [redemptionQty, setRedemptionQty] = useState(fund?.balance)

  const [fullSell, setFullSell] = useState(false)

  const [isLoading, setIsLoading] = useState(false)

  const setMessageModalState = useSetRecoilState(messageModalState)
  const userData = JSON.parse(localStorage.getItem('userData'))
  const clientCode = userData?.uid.split('-')[0]
  const { showError } = useErrorPopup()

  const [src, setSrc] = useState('')
  const handleError = () => {
    setSrc(null)
  }

  let ifscCode = bankDetails?.ifscCode
  const extractedBranch = ifscCode?.match(/^[A-Za-z]{4}/)[0]?.toLowerCase()
  const iconSrc = `${env.BANK_LOGOS}/${extractedBranch}/symbol.svg`
  useEffect(() => {
    setSrc(iconSrc)
  }, [iconSrc])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    
    // Track redeem button clicked
    if (fundDetails) {
      PostHogTracker.redeemButtonClicked(fundDetails.schemeName, fund?.holding)
      PostHogTracker.pageViewed('Redeem Fund', {
        fund_name: fundDetails.schemeName,
        current_value: fund?.holding
      })
    }
  }, [])

  const handleRedemptionAmountChange = (e) => {
    let value = e.target.value

    // Prevent non-numeric characters except dot
    value = value.replace(/[^0-9.]/g, '')

    // Allow only two decimal places
    if (value.includes('.')) {
      const [integerPart, decimalPart] = value.split('.')
      value = decimalPart.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : value
    }

    // Convert to number and handle edge cases
    const numericValue = Number(value)
    if (!isNaN(numericValue) && numericValue >= 0) {
      setRedemptionAmount(value)
      
      // Track redemption amount entered (only if significant change)
      if (numericValue > 0 && value.length > 2) {
        PostHogTracker.redemptionAmountEntered(numericValue, fundDetails?.schemeName)
        if (!fullSell && numericValue < fund?.holding) {
          PostHogTracker.partialRedemptionSelected(fundDetails?.schemeName, numericValue)
          PostHogTracker.redemptionTypeSelected('Partial')
        }
      }
    }
  }

  const handleFullSell = () => {
    setRedemptionQty(fund?.balance), setRedemptionAmount(fund?.holding.toFixed(3))
    setFullSell(true)
    
    // Track full redemption selected
    PostHogTracker.fullRedemptionSelected(fundDetails?.schemeName, fund?.balance)
    PostHogTracker.redemptionTypeSelected('Full')
  }

  const redeemOrder = async () => {
    // Track redemption order placed
    PostHogTracker.redemptionOrderPlaced(
      fundDetails?.schemeName,
      redemptionAmount,
      redemptionQty,
      fullSell ? 'Full' : 'Partial'
    )
    
    showError(
      'Redemption Failed!',
      'There was an issue with redemption. Please try again later. For assistance, contact us at +91-9035189836.',
      () => {},
    )
    PostHogTracker.redemptionFailed(fundDetails?.schemeName, 'Redemption temporarily disabled')
    return

    try {
      setIsLoading(true)

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        schemeCode: fundDetails?.bseSchemeCode,
        folioNumber: '488372580475',
        withdrawableAmount: redemptionAmount,
        isAllRedeem: 'Y',
        phoneNumber: formatIndianNumber(userDetails?.phoneNumber),
        isin: fundDetails?.isin,
      }

      const response = await post('mutualfundservice/api/bseStar/mfOrder/redeemOrder', payload)

      setIsLoading(false)

      if (!response.isError && response?.status === 'SUCCESS') {
        // Track redemption success
        PostHogTracker.redemptionSuccess(fundDetails?.schemeName, redemptionAmount)
        onOpen('openPopup', {
          title: 'Redemption Order Processed',
          message:
            'Your redemption order is being processed and the amount will be credited to your bank account shortly.',
          severity: 'info',
        })
      }

      if (response.isError) {
        showError(
          'Redemption Failed',
          'There was an issue processing your redemption order. Please try again later or contact support for assistance.',
          () => {},
        )
      }
    } catch (error) {
      console.log('🚀 ~ redeemOrder ~ error:', error)
    }
  }

  function getFundReturn(fundPortfolio) {
    const mainInfo = fundPortfolio?.contents?.mainInfo?.[0]

    if (mainInfo?.threeYearReturn != null) {
      return `${mainInfo.threeYearReturn.toFixed(2)}`
    } else if (mainInfo?.fiveYearReturn != null) {
      return `${mainInfo.fiveYearReturn.toFixed(2)}`
    } else if (mainInfo?.oneYearReturn != null) {
      return `${mainInfo.oneYearReturn.toFixed(2)}`
    } else {
      return 0
    }
  }

  return (
    <>
      <div className='bg-white'>
        <div className='max-w-md mx-auto min-h-screen pb-12'>
          <div
            className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 lg:px-0'
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className='h-5 w-5' />
            Redeem
          </div>

          <div className='max-w-[360px] mx-auto h-full flex flex-col gap-y-12 justify-between'>
            <div className='h-[170px] w-full bg-cover flex justify-center items-center p-2 z-0 relative'>
              <div
                className='absolute inset-0 bg-cover w-full h-full'
                style={{ backgroundImage: `url(${PlaceOrderBg})` }}
              />
              <div
                className='absolute inset-0'
                style={{
                  background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
                  // boxShadow: '0px 16px 24px rgba(65, 85, 141, 0.08)',
                }}
              />
              <div className='flex items-center space-x-4 z-10'>
                <img
                  src={`${env.MF_LOGOS_URL}/${fundDetails?.amcCode}.png`}
                  alt={fundDetails.legalName}
                  className='w-12 h-12 border rounded-lg'
                />
                <div>
                  <h3
                    className='font-semibold text-sm leading-tight text-wrap w-48'
                    style={{ textWrap: 'pretty' }}
                  >
                    {sanitizeName(fundDetails)}
                  </h3>
                  {fundPortfolio.state === 'hasValue' && (
                    <p className='text-sm text-muted-foreground flex gap-x-2'>
                      Returns (
                      {fundPortfolio?.contents?.mainInfo[0]?.threeYearReturn != null
                        ? '3Y'
                        : fundPortfolio?.contents?.mainInfo[0]?.fiveYearReturn != null
                        ? '5Y'
                        : '1Y'}
                      ){' '}
                      <span
                        className={`font-bold text-black-500 ${
                          getFundReturn(fundPortfolio) < 0 ? 'text-error-600' : 'text-secondary-600'
                        }`}
                      >
                        {getFundReturn(fundPortfolio)} %
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div>
              <div className='flex justify-between'>
                <span className='text-xs text-black-400'>Current amount</span>
                <span className='font-semibold text-black-500'>₹ {toCurrency(fund?.holding)}</span>
              </div>

              {/* <div className='flex justify-between'>
                <span className='text-xs text-black-400 flex gap-x-1 items-center'>
                  Current folio value <Info fontSize='16px' color='gray' />
                </span>
                <span className='font-semibold text-black-500'>
                  ₹ {toCurrency(fundDetails.holding)}
                </span>
              </div> */}
            </div>

            <div className='flex flex-col justify-center items-center gap-1.5'>
              <Label htmlFor='amount' className='text-black-400 text-xs'>
                Redemption amount
              </Label>
              <div className='relative'>
                <Input
                  startAdornment='₹'
                  type='amount'
                  id='amount'
                  placeholder='Amount'
                  className='border-none outline-none max-w-[120px] mx-auto'
                  value={redemptionAmount}
                  onChange={handleRedemptionAmountChange}
                />
                {redemptionAmount > 0 && (
                  <Button
                    type='button'
                    variant='ghost'
                    size='sm'
                    className='absolute right-2 top-1/2 h-auto -translate-y-1/2 p-0.5 bg-black-200 text-white rounded-full hover:bg-black-200'
                    onClick={() => setRedemptionAmount(0)}
                  >
                    <X className='h-3 w-3 text-white' />
                    <span className='sr-only'>Clear input</span>
                  </Button>
                )}
              </div>
              {/* <p className='text-xs text-error-600 text-center'>
                Minimum first investment amount is ₹ {toCurrency(fundDetails?.minInvt)}
              </p> */}
            </div>

            <div className='flex justify-center gap-x-2'>
              {[25, 50, 75].map((btn, index) => (
                <Button
                  key={(btn + index).toString()}
                  size='simple'
                  className='px-3 py-[2px] rounded-[50px] bg-error-50 hover:bg-error-50 text-error-500'
                  onClick={() => {
                    setRedemptionQty(((fund?.balance / 100) * btn).toFixed(4)),
                      setRedemptionAmount(((fund?.holding / 100) * btn).toFixed(3)),
                      setFullSell(false)
                  }}
                >
                  {toCurrency(btn)} %
                </Button>
              ))}

              <Button
                size='simple'
                className='px-3 py-[2px] rounded-[50px] bg-error-50 hover:bg-error-50 text-error-500'
                onClick={handleFullSell}
              >
                All
              </Button>
            </div>

            <div className='flex flex-col gap-y-4'>
              <Card className='flex items-center gap-3 p-4 w-full bg-white shadow-none border-[#D3DBEC] rounded-2xl'>
                <div className='flex items-center justify-center w-10 h-10 rounded-full border'>
                  {src ? (
                    <img src={src} alt='bank logos' onError={handleError} height={24} width={24} />
                  ) : (
                    <AccountBalance className='text-primary-200 w-5 h-5' />
                  )}
                  {/* <AccountBalance className='w-5 h-5' /> */}
                </div>
                <div className='flex flex-col'>
                  <h3 className='font-semibold leading-6 text-black-500'>
                    {bankDetails && bankDetails?.accountHolderName}
                  </h3>
                  <p className='text-sm text-black-400 leading-5 text-nowrap'>
                    <span className='font-semibold'>{bankDetails && bankDetails?.bankName}</span>
                    <span className='font-medium'> A/c ending in </span>
                    <span className='font-semibold'>
                      {bankDetails && bankDetails?.accountNo && bankDetails?.accountNo?.slice(-4)}
                    </span>
                  </p>
                </div>
              </Card>

              <Button
                className='rounded-xl flex-1 bg-error-500 hover:bg-error-400 disabled:bg-error-200'
                loading={isLoading}
                disabled={!redemptionAmount}
                onClick={() => redeemOrder()}
              >
                Redeem Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MFRedeem
